
import { Helmet } from 'react-helmet';
import StripeDiagnostics from '@/components/admin/StripeDiagnostics';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const StripeDiagnosticsPage = () => {
  const { isAdmin } = useAuth();
  
  // Only allow admins to access this page
  if (!isAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <Helmet>
        <title>Stripe Diagnostics | Travel CMS</title>
      </Helmet>
      <div className="space-y-4">
        <h1 className="text-2xl font-bold">Stripe Diagnostics</h1>
        <p className="text-muted-foreground">
          This page helps diagnose issues with the Stripe integration.
        </p>
        <StripeDiagnostics />
      </div>
    </>
  );
};

export default StripeDiagnosticsPage;
